import { useReducer } from 'react';
import { isConfigActivated, getConfig } from '../../firebase';
import useEvent from '../../hooks/useEvent';

let features = null;

function useFeatureConfig() {
  const configActive = isConfigActivated();
  const [, forceRender] = useReducer(s => s + 1, 0);

  useEvent('remoteConfigActivated', forceRender);

  if (!configActive) {
    return {};
  }

  if (!features) {
    features = {};
    const config = getConfig();
    Object.entries(config.getAll()).forEach(([k, v]) => {
      if (!/^feature_/.test(k)) return;
      const key = k.substr(8);
      try {
        features[key] = JSON.parse(v.asString());
        features[key].name = key;
      } catch (e) {
        console.error(`failed to parse feature "${key}"`);
      }
    });
  }

  return features;
}

export default useFeatureConfig;
